import {
  WORKSHEET_STEP_LOADING_STATUSES,
  WorksheetTaskStatusType,
} from 'notebook/worksheets/WorksheetConstants';

// see document for method & step status transitions
// https://docs.google.com/document/d/19DmvEtJtwEDUvJVASLriQiwSu7pxuGYJqVduNPp64ZU

const WORKSHEET_STEP_DOCUMENT_EDITABLE_STATUSES = [WorksheetTaskStatusType.READY];

export interface WorksheetSelectedStepControlFlags {
  isSelectedStepActionsLocked: boolean;
  isSelectedStepDocumentLocked: boolean;
}

/**
 * Function to output booleans that control the UI behavior of WorksheetStepFrame
 * @param isWorksheetPending boolean indicating if worksheet is in pending state
 * @param selectedStepGroupIndex the step-group index of the selected step
 * @param selectedStepTaskDataStatus status of task data of selected step output by function WorksheetUtils.extractTaskData
 * @param numWorksheetStepGroups number of worksheet step-groups in worksheet
 * @param isWorksheetInReview review of the worksheet
 * @returns see interface UseWorksheetSelectedStepStatus
 */
export const getSelectedStepControlFlags = (
  isWorksheetPending: boolean,
  selectedStepGroupIndex: number | undefined,
  selectedStepTaskDataStatus: WorksheetTaskStatusType | undefined,
  numWorksheetStepGroups: number,
  isWorksheetInReview?: boolean
): WorksheetSelectedStepControlFlags => {
  // selectedStep is a step in run step-group and worksheet has not started run yet (in Pending state)
  const selectedStepIsPendingRunGroupStep =
    isWorksheetPending &&
    selectedStepGroupIndex !== 0 && // corresponding to pre-run step-group
    selectedStepGroupIndex !== numWorksheetStepGroups - 1; // corresponding to post-run step-group

  // selectedStep has a task status that indicates the document is not editable
  const selectedStepHasNotEditableDocumentStatus = selectedStepTaskDataStatus
    ? !WORKSHEET_STEP_DOCUMENT_EDITABLE_STATUSES.includes(selectedStepTaskDataStatus)
    : true;

  const isStepStatusLoading =
    selectedStepTaskDataStatus != null &&
    WORKSHEET_STEP_LOADING_STATUSES.includes(selectedStepTaskDataStatus);

  // assemble UI control booleans
  const isSelectedStepActionsLocked = selectedStepIsPendingRunGroupStep || isStepStatusLoading;
  const isSelectedStepDocumentLocked =
    selectedStepIsPendingRunGroupStep || selectedStepHasNotEditableDocumentStatus || isStepStatusLoading;

  if (isWorksheetInReview) {
    return {
      isSelectedStepActionsLocked: true,
      isSelectedStepDocumentLocked: true,
    };
  }

  return {
    isSelectedStepActionsLocked,
    isSelectedStepDocumentLocked,
  };
};
